// Link de um caso nas listagens do site: casos com site próprio (external_url, cadastrado no
// backoffice) abrem esse endereço em nova aba; os demais seguem para a página de detalhes.
// Uso: <component :is="hasExternalSite(item) ? 'a' : 'router-link'" v-bind="caseLinkProps(item, rota)">
export function externalSite(item) {
    const url = item && typeof item.external_url === 'string' ? item.external_url.trim() : '';
    return /^https?:\/\//i.test(url) ? url : '';
}

export function hasExternalSite(item) {
    return !!externalSite(item);
}

export function caseLinkProps(item, detailsRoute) {
    const url = externalSite(item);
    if (url) return { href: url, target: '_blank', rel: 'noopener noreferrer' };
    return { to: detailsRoute };
}
